import React, { useRef, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { BTN_CHOOSE_ATTACH } from '../theme/poButtonTokens';

const BLUE = '#315087';
const BLUE_BORDER = '#A6BCD1';
const BLUE_LIGHT = '#f3f8fd';

export interface AttachFileZoneProps {
  onFile: (file: File) => void;
  subtitle?: string;
}

export const AttachFileZone: React.FC<AttachFileZoneProps> = ({
  onFile,
  subtitle = 'Drag files here · not imported into the document',
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);
    files.forEach(onFile);
    if (e.target) e.target.value = '';
  };
  const onDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragging(false);
    Array.from(e.dataTransfer.files ?? []).forEach(onFile);
  };

  return (
    <Box
      className="no-print"
      onDragOver={e => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={onDrop}
      sx={{
        display: 'flex', alignItems: 'center', gap: 1.5,
        px: 2, py: 1.1, borderRadius: 2.5,
        border: `1.5px dashed ${dragging ? BLUE : BLUE_BORDER}`,
        backgroundColor: dragging ? '#e3f0fb' : BLUE_LIGHT,
        transition: 'all .15s',
      }}
    >
      <input ref={inputRef} type="file" multiple hidden onChange={onInput} />
      <AttachFileIcon sx={{ fontSize: 20, color: BLUE, flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: BLUE, lineHeight: 1.2 }}>
          Attach file
        </Typography>
        <Typography sx={{ fontSize: '0.72rem', color: '#7d96ad', fontStyle: 'italic' }}>
          {subtitle}
        </Typography>
      </Box>
      <Button disableElevation onClick={() => inputRef.current?.click()} sx={BTN_CHOOSE_ATTACH}>
        Choose file
      </Button>
    </Box>
  );
};

export default AttachFileZone;
